import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "oktell-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_state = _resolveComponent("page-state")!
  const _component_ok_invoice_header = _resolveComponent("ok-invoice-header")!
  const _component_ok_wait_list = _resolveComponent("ok-wait-list")!
  const _component_ok_invoice_content = _resolveComponent("ok-invoice-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createBlock(_component_page_state, {
          key: 0,
          loading: _ctx.state.is_loading,
          "loading-message": "Загрузка данных накладной...",
          failed: _ctx.state.is_failed,
          "failed-message": "При загрузке данных накладной произошла ошибка",
          onReload: _ctx.loadInvoice
        }, null, 8, ["loading", "failed", "onReload"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ok_invoice_header, {
            invoiceNumber: _ctx.state.invoice.invoice_number,
            onDateConfirm: _ctx.loadInvoice
          }, null, 8, ["invoiceNumber", "onDateConfirm"]),
          _createVNode(_component_ok_wait_list),
          _createVNode(_component_ok_invoice_content, {
            class: "mt-8",
            invoice: _ctx.state.invoice,
            "client-sla-date": _ctx.statuses_state.client_sla_date,
            "statuses-loading": _ctx.statuses_state.is_loading,
            "statuses-failed": _ctx.statuses_state.is_failed,
            statuses: _ctx.statuses_state.list,
            "problems-loading": _ctx.problems_state.is_loading,
            "problems-failed": _ctx.problems_state.is_failed,
            problems: _ctx.problems_state.list,
            onReloadStatuses: _ctx.loadInvoiceStatuses,
            onReloadProblems: _ctx.loadInvoiceProblems
          }, null, 8, ["invoice", "client-sla-date", "statuses-loading", "statuses-failed", "statuses", "problems-loading", "problems-failed", "problems", "onReloadStatuses", "onReloadProblems"])
        ], 64))
  ]))
}